import React, { useState, useEffect } from "react";
import Hero from "../Hero/Hero";
import regionsImage from "assets/img/forest-service-regions.png";
import "./Contact.css";

const Contact = () => {
  const [announcement, setAnnouncement] = useState("");

  // Initial load
  useEffect(() => {
    window.scroll(0, 0);
    setAnnouncement("You are now on the Contacts page");
    document.title = "Forest Pest Conditions - Contacts";
  }, []);
  return (
    <>
      <Hero value="Contacts" />
      <main className="grid-container contact-page" id="main-content">
        <div className="grid-row">
          <h1 className="main-heading">U.S. Forest Service Regions</h1>
        </div>
        <div className="visually-hidden" aria-live="polite">
          {announcement}
        </div>
        <div>
          <center>
            <img
              src={regionsImage}
              width="80%"
              id="forest-service-regions"
              alt="A map of the U.S. showing the 9 Forest Service regions by state"
              className="center"
            />
            <br />A tabular version of the map data is in the{" "}
            <a href="#region-definition-table">Region Definitions table</a>.
          </center>
        </div>
        <hr className="mobile-disappear" />
        <div className="grid-row">
          <div className="grid-col-12">
            <h2>Regional Forest Service Offices</h2>
            <p>
              For additional information, you can contact your regional U.S.
              Forest Service office from the list below.
            </p>
          </div>
        </div>
        <div className="grid-row">
          <div className="tablet:grid-col-6 mobile-lg:grid-col-12 margin-right">
            <p>
              <b>Forest Service National Office</b>
              <br />
              1400 Independence Avenue SW
              <br />
              Washington, DC 20250
              <br />
              (800) 832-1355
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r1/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Northern Region (R1)
                </a>
              </b>
              <br />
              Federal Building
              <br />
              26 Fort Missoula Road
              <br />
              Missoula, MT 59804
              <br />
              (406) 329-3511
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r2/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Rocky Mountain Region (R2)
                </a>
              </b>
              <br />
              1617 Cole Boulevard, Building 17
              <br />
              Lakewood, CO 80401
              <br />
              (303) 275-5350
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r3/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Southwestern Region (R3)
                </a>
              </b>
              <br />
              333 Broadway Boulevard SE
              <br />
              Albuquerque, NM 87102
              <br />
              (505) 842-3292
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r4/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Intermountain Region (R4)
                </a>
              </b>
              <br />
              Federal Building
              <br />
              324 25th Street
              <br />
              Ogden, UT 84401
              <br />
              (801) 625-5605
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r5/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Pacific Southwest Region (R5)
                </a>
              </b>
              <br />
              1323 Club Drive
              <br />
              Vallejo, CA 94592
              <br />
              (707) 562-8737
            </p>
          </div>
          <div className="tablet:grid-col-6 mobile-lg:grid-col-12 margin-left">
            <p className="contact-paragraph-no-margin">
              <b>
                <a
                  href="https://www.fs.usda.gov/r6/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Pacific Northwest Region (R6)
                </a>
              </b>
              <br />
              333 SW First Avenue
              <br />
              Portland, OR 97204
              <br />
              (503) 808-2468
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r8/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Southern Region (R8)
                </a>
              </b>
              <br />
              1720 Peachtree Road NW
              <br />
              Atlanta, GA 30309
              <br />
              (404) 347-4400
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r9/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Eastern Region (R9)
                </a>
              </b>
              <br />
              626 East Wisconsin Avenue
              <br />
              Milwaukee, WI 53202
              <br />
              (414) 297-3600
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/r10/"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Alaska Region (R10)
                </a>
              </b>
              <br />
              PO Box 21628
              <br />
              Juneau, AK 99802
              <br />
              (907) 586-8806
            </p>
            <p>
              <b>
                <a
                  href="https://research.fs.usda.gov/iitf"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  International Institute of Tropical Forestry
                </a>
              </b>
              <br />
              1201 Calle Ceiba
              <br />
              Jardín Botánico Sur
              <br />
              San Juan, PR 00926
              <br />
              (787) 766-5335
            </p>
            <p>
              <b>
                <a
                  href="https://www.fs.usda.gov/science-technology/forest-health-protection/assessment-applied-sciences"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Forest Health Assessment & Applied Sciences Team
                </a>
              </b>
              <br />
              2150 Centre Avenue
              <br />
              Building A, Suite 331
              <br />
              Fort Collins, CO 80526
              <br />
              (970) 295-5839
            </p>
          </div>
        </div>
        <hr className="mobile-disappear" />
        <div className="grid-row" id="region-definition-table">
          <div className="grid-col-12">
            <h2>Region Definitions</h2>
          </div>
        </div>
        <div className="grid-row">
          <table aria-label="Region Definitions" className="usa-table">
            <thead>
              <tr>
                <th tabIndex="0" scope="col" aria-label="Region number">
                  REGION
                </th>
                <th tabIndex="0" scope="col" aria-label="Region name">
                  REGION NAME
                </th>
                <th
                  tabIndex="0"
                  scope="col"
                  aria-label="States included in region"
                >
                  INCLUDED STATES
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Northern Region</td>
                <td>
                  Montana, northern Idaho, North Dakota, northwestern South
                  Dakota
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Rocky Mountain Region</td>
                <td>
                  Colorado, Kansas, Nebraska, most of South Dakota, eastern
                  Wyoming
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Southwestern Region</td>
                <td>Arizona, New Mexico</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Intermountain Region</td>
                <td>southern Idaho, Nevada, Utah, western Wyoming</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Pacific Southwest Region</td>
                <td>
                  California, Hawaii, Guam, Trust Territories of the Pacific
                  Islands
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>Pacific Northwest Region</td>
                <td>Washington, Oregon</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Southern Region</td>
                <td>
                  Alabama, Arkansas, Florida, Georgia, Kentucky, Louisiana,
                  Mississippi, North Carolina, Oklahoma, South Carolina,
                  Tennessee, Texas, Virgin Islands, Virginia
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>Eastern Region</td>
                <td>
                  Connecticut, Delaware, Illinois, Indiana, Iowa, Maine,
                  Maryland, Massachusetts, Michigan, Minnesota, Missouri, New
                  Hampshire, New Jersey, New York, Ohio, Pennsylvania, Rhode
                  Island, Vermont, West Virginia, Wisconsin
                </td>
              </tr>
              <tr>
                <td>10</td>
                <td>Alaska Region</td>
                <td>Alaska</td>
              </tr>
              <tr>
                <td>IITF</td>
                <td>International Institute of Tropical Forestry</td>
                <td>Puerto Rico, Virgin Islands</td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
    </>
  );
};

export default Contact;
